import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';
import { InputBase } from '@mui/material';

const PhoneNumberInputMask = forwardRef((props, ref) => {
	const { onChange, ...other } = props;
	return (
		<IMaskInput
			{...other}
			mask="(#00) 000-0000"
			definitions={{
				'#': /[1-9]/,
			}}
			inputRef={ref}
			onAccept={(value) => onChange({ target: { name: props.name, value } })}
			overwrite
		/>
	);
})

const PhoneNumberInput = (props) => {
	return (
		<InputBase {...props} inputComponent={PhoneNumberInputMask} />
	)
}

PhoneNumberInput.defaultProps = {
	onChange: () => {}
}

PhoneNumberInput.propTypes = {
	onChange: PropTypes.func,
}


export default PhoneNumberInput;